import { useState } from 'react'
import { useAuth } from './AuthContext'
import { Shield } from 'lucide-react'

export default function LoginPage() {
  const { signInWithGoogle, authError, loading } = useAuth()
  const [isSigningIn, setIsSigningIn] = useState(false)

  const handleGoogleSignIn = async () => {
    try {
      setIsSigningIn(true)
      await signInWithGoogle()
    } catch (err) {
      console.error('Sign in failed:', err)
      setIsSigningIn(false)
    }
  }

  return (
    <main dir="rtl" className="relative min-h-screen flex items-center justify-center overflow-hidden bg-cream">

      {/* Mesh background */}
      <div className="fixed inset-0 z-0 pointer-events-none" style={{
        background: `
          radial-gradient(ellipse 70% 50% at 80% 10%, rgba(82,183,136,0.13) 0%, transparent 60%),
          radial-gradient(ellipse 60% 40% at 10% 85%, rgba(244,132,95,0.10) 0%, transparent 55%),
          #FAF7F2
        `,
      }} />
      <div className="fixed z-0 pointer-events-none rounded-full opacity-50" style={{
        width: 400, height: 400,
        background: 'rgba(82,183,136,0.15)',
        filter: 'blur(80px)', top: -100, right: -100,
      }} />
      <div className="fixed z-0 pointer-events-none rounded-full opacity-50" style={{
        width: 300, height: 300,
        background: 'rgba(244,132,95,0.12)',
        filter: 'blur(80px)', bottom: -80, left: -80,
      }} />

      <div className="relative z-10 flex flex-col items-center gap-6 w-full max-w-[420px] px-4 py-6">

        {/* Logo */}
        <div className="flex items-center gap-2.5">
          <span className="text-[28px] leading-none">🌿</span>
          <span className="text-[26px] tracking-[-0.02em] text-[#F4845F]"
            style={{ fontFamily: "'Playfair Display', serif" }}>
            i<strong className="text-green-primary font-bold">Market</strong>
          </span>
        </div>

        {/* Card */}
        <div className="w-full bg-white rounded-3xl flex flex-col gap-7 px-9 py-10"
          style={{ boxShadow: '0 2px 8px rgba(44,24,16,0.06), 0 20px 48px rgba(44,24,16,0.10)' }}>

          <div className="text-center">
            <h1 className="text-[28px] font-bold text-text-primary tracking-[-0.02em] mb-1.5"
              style={{ fontFamily: "'Playfair Display', serif" }}>
              ברוכים הבאים
            </h1>
            <p className="text-sm text-text-secondary">התחברו כדי להמשיך</p>
          </div>

          {/* Error */}
          {authError && (
            <span className="py-1.5 px-2.5 text-yellow-700 border border-yellow-300 bg-yellow-100 rounded-lg text-sm text-center">
              ⚠️ {authError}
            </span>
          )}

          {/* Google Button */}
          <button
            onClick={handleGoogleSignIn}
            disabled={isSigningIn || loading}
            className="w-full flex items-center justify-center gap-3 px-4 py-3.5 
            border border-cream-dark rounded-xl hover:bg-cream transition-colors 
            disabled:opacity-50 cursor-pointer disabled:cursor-not-allowed"
          >
            <svg className="w-5 h-5 shrink-0" viewBox="0 0 24 24">
              <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
              <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
              <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
              <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
            </svg>
            <span className="text-[15px] font-semibold text-text-primary">
              {isSigningIn ? 'מתחבר...' : 'התחברות עם Google'}
            </span>
          </button>

          <div className="flex items-center justify-center gap-2 text-[12px] text-text-muted pt-1 border-t border-cream-dark">
            <span>גישה מוגבלת למשתמשים מורשים בלבד</span>
            <Shield className="h-3 w-3" /> 
          </div>
        </div>

        <p className="text-[12px] text-text-muted text-center">
          © 2026 iMarket · כל הזכויות שמורות
        </p>
      </div>
    </main>
  )
}